import React, { Component } from "react";
import Moment from "moment";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import CheckBoxGroup from "../../common/form/checkBoxGroup";
import { getExtracoesPredatada } from "../utils/extracaoUtils";
import { recuperaExtracaoByData } from "../../reducers/relatorios/extracoesActions";
import { setExtracoesSelecionadas } from "../../reducers/loteria/loteriaActions";
import { Sistema_ID } from "../../modules/constants";
import { getOrientation } from "../../modules/helpers";

import "./extracao.css";
import { forceInt } from "../../utils/forceInt";

class ExtracaoSelector extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selected: null,
      dataAposta: Moment().format("YYYY-MM-DD HH:mm:ss"),
      extracaoDoDia: [],
    };

    this.onClick = this.onClick.bind(this);
    this.loadExtracao = this.loadExtracao.bind(this);
    this.extracaoCallBack = this.extracaoCallBack.bind(this);

    this.loadExtracao();
    this.props.dateSelect(this.state.dataAposta);

    this.checkBoxGroupElement = React.createRef();
  }

  onClick(data) {
    this.props.setExtracoesSelecionadas([])
    this.setState({ dataAposta: data });
    this.props.dateSelect(data);
    this.loadExtracao(data);
  }

  extracaoCallBack() {
    var arr = getExtracoesPredatada(
      this.props.extracaoDoDia,
      this.state.dataAposta
    );
    this.setState({ extracaoDoDia: arr });
    this.clear();
    if (this.checkBoxGroupElement.current != null)
      this.checkBoxGroupElement.current.clearState();
  }

  loadExtracao(data) {
    // this.setState({
    //     isLoading: true
    // });

    var transaction = {};
    transaction.Sistema_ID = Sistema_ID;
    transaction.Cliente_ID = this.props.objUser.Cliente_ID;
    transaction.Site_ID = forceInt(this.props.objUser.Site_ID);
    transaction.chrSerial = this.props.objUser.ChrSerial;
    transaction.Session_ID = this.props.objUser.Session_ID;
    transaction.SessionIDLE = this.props.objUser.SessionIDLE;
    transaction.LoginLE = this.props.objUser.LoginLE;
    transaction.sdtData = data;

    this.props.recuperaExtracaoByData(transaction, this.extracaoCallBack);
  }

  createDateButtons() {
    var moment = require("moment");
    var now = moment();
    var arrOptions = [];

    var diasPre = this.props.config.tnyQtdDiasPre;
    if (getOrientation() == "portrait" && !this.props.isNewDesign) {
      for (var i = 0; i < diasPre; i++) {
        if (i == 0) {
          arrOptions.push(
            <option value={now.format("YYYY-MM-DD HH:mm:ss")}>
              {`Hoje - ${now.format("DD/MM/YY")}`}
            </option>
          );
        } else if (i == 1) {
          var novaData = moment().add(1, "days");
          arrOptions.push(
            <option value={novaData.format("YYYY-MM-DD 00:00:00")}>
              {`Amanhã - ${novaData.format("DD/MM/YY")}`}
            </option>
          );
        } else {
          var novaData = moment().add(i, "days");
          arrOptions.push(
            <option value={novaData.format("YYYY-MM-DD 00:00:00")}>
              {`${novaData
                .format("dddd", "pt")
                .replace("-feira", "")} - ${novaData.format("DD/MM/YY")}`}
            </option>
          );
        }
      }

      return (
        <select
          class="form-control"
          onChange={(e) => this.onClick(e.target.value)}
        >
          {arrOptions}
        </select>
      );
    } else {
      for (var i = 0; i < diasPre; i++) {
        if (i == 0) {
          arrOptions.push(
            <button
              className={
                "btn btn-success btn-extracao" +
                `${
                  moment(this.state.dataAposta).format("YYYY-MM-DD") ===
                  now.format("YYYY-MM-DD")
                    ? " active"
                    : ""
                }`
              }
              onClick={(ev) => this.onClick(ev.target.getAttribute("dataref"))}
              dataref={now.format("YYYY-MM-DD HH:mm:ss")}
            >
              <span className="bt-extracao-line-1">Hoje</span>
              <span className="bt-extracao-line-2">
                {now.format("DD/MM/YY")}
              </span>
            </button>
          );
        } else if (i == 1) {
          var novaData = moment().add(1, "days");
          arrOptions.push(
            <button
              className={
                "btn btn-success btn-extracao" +
                `${
                  moment(this.state.dataAposta).format("YYYY-MM-DD") ===
                  novaData.format("YYYY-MM-DD")
                    ? " active"
                    : ""
                }`
              }
              onClick={(ev) => this.onClick(ev.target.getAttribute("dataref"))}
              dataref={novaData.format("YYYY-MM-DD 00:00:00")}
            >
              <span className="bt-extracao-line-1">Amanhã</span>
              <span className="bt-extracao-line-2">
                {novaData.format("DD/MM/YY")}
              </span>
            </button>
          );
        } else {
          var novaData = moment().add(i, "days");
          arrOptions.push(
            <button
              className={
                "btn btn-success btn-extracao" +
                `${
                  moment(this.state.dataAposta).format("YYYY-MM-DD") ===
                  novaData.format("YYYY-MM-DD")
                    ? " active"
                    : ""
                }`
              }
              onClick={(ev) => this.onClick(ev.target.getAttribute("dataref"))}
              dataref={novaData.format("YYYY-MM-DD 00:00:00")}
            >
              <span className="bt-extracao-line-1">
                {novaData.format("dddd", "pt").replace("-feira", "")}
              </span>
              <span className="bt-extracao-line-2">
                {novaData.format("DD/MM/YY")}
              </span>
            </button>
          );
        }
      }

      return <div className="extracoes">{arrOptions}</div>;
    }
  }

  clear() {
    var lstChk = document.getElementsByClassName(this.props.groupName);
    for (var i = 0; i <= lstChk.length - 1; i++) {
      lstChk[i].checked = false;
    }
  }

  getComponenteExtracao() {
    return (
      <CheckBoxGroup
        ref={this.checkBoxGroupElement}
        dataArray={this.state.extracaoDoDia}
        handleChange={this.props.handleChange}
        groupName={this.props.groupName}
      ></CheckBoxGroup>
    );
  }

  render() {
    return (
      <div className="extracaoSelector">
        <div role="form" className="loteriaBody div-center">
          <div className="col-md-10">
            <section
              className="row"
              style={{
                paddingLeft: "15px",
                maxWidth: "1200px",
                margin: "0 auto",
                marginBottom: "5px",
              }}
            >
              <section className="col-md-12 modalidade-input-container-title">
                <h3 style={{ display: "inline" }}>Sorteios</h3>
              </section>
            </section>
            <div className="concurso-input-container text-center">
              <section className="row concurso-input-container">
                {this.createDateButtons()}
              </section>
            </div>
          </div>
        </div>
        <label className="extractions-title">Extração</label>
        {this.getComponenteExtracao()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  extracoes: state.usuario.objUser.arrExtracoes,
  objUser: state.usuario.objUser,
  config: state.usuario.objUser.config,
  isFetching: state.carrinho.isFetching,
  extracaoDoDia: state.extracoes.extracaoDoDia,
  isNewDesign: state.settings.isNewDesign,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      recuperaExtracaoByData,
      setExtracoesSelecionadas,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ExtracaoSelector);



// WEBPACK FOOTER //
// ./src/loteria/extracao/extracaoSelector.jsx